import { useQuery } from "@tanstack/react-query";
import { useApp } from "./app-context.tsx";
import type { Copy } from "./brand.ts";

/** Unique-user download count per design id for this brand; empty without an API. */
export function useDownloadStats() {
  const { api, brand } = useApp();
  return useQuery({
    queryKey: ["downloads", brand.config.id],
    queryFn: async () => (await api!.downloadStats()).designs,
    enabled: !!api,
    staleTime: 60_000,
  });
}

/** "1 download" / "1,234 downloads" in the active locale. */
export function formatDownloads(copy: Copy, count: number, locale: string): string {
  return count === 1 ? copy("downloads.one") : copy("downloads.other", { count: count.toLocaleString(locale) });
}
